import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeMarketBonusContainer } from './home-market-bonus-container/home-market-bonus.container';
import { AuthorizationGuard } from '../../core/store/session/authorization/authorization.resolve';
import { DependencyTreeGuard } from '../../core/guards/dependency-tree.guard';
import { CustomerInfoLoadIfSelectedGuard } from '../../core/guards/customer-info-load-if-selected.guard';

const routes: Routes = [
  {
    path: 'home-market-bonus',
    component: HomeMarketBonusContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CustomerInfoLoadIfSelectedGuard, AuthorizationGuard],
      authorization: 'canAccessHomeMarketBonus',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeMarketBonusRoutingModule {}
